import { useState } from 'react'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import CheckIcon from '@mui/icons-material/Check'
import { Box, Typography } from '@mui/material'

/** CONSTANTS */
import { colors } from 'constants/theme'

type PatientEnglishNameTooltipProps = {
  firstnameEn?: string
  lastnameEn?: string
}

export default function PatientEnglishNameTooltip(props: PatientEnglishNameTooltipProps) {
  const { firstnameEn, lastnameEn } = props
  const [copied, setCopied] = useState(false)

  if (!firstnameEn && !lastnameEn) return null

  const fullEnglishName = `${firstnameEn || ''} ${lastnameEn || ''}`.trim()

  const copyToClipboard = (text: string) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).catch(() => fallbackCopy(text))
    } else {
      fallbackCopy(text)
    }
  }

  const fallbackCopy = (text: string) => {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
  }

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation()
    copyToClipboard(fullEnglishName)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
      <Typography sx={{ fontSize: '14px !important', color: colors.black, lineHeight: 1.2 }}>
        {fullEnglishName}
      </Typography>
      {copied ? (
        <CheckIcon sx={{ fontSize: '14px !important', color: '#8BC34A', cursor: 'pointer' }} onClick={handleCopy} />
      ) : (
        <ContentCopyIcon
          onClick={handleCopy}
          sx={{ fontSize: '14px !important', color: colors.black, cursor: 'pointer' }}
        />
      )}
    </Box>
  )
}
